import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { Badge } from "../common/Brutal";
import { api } from "../../lib/api";

export const LandingSchedule = () => {
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);

  useEffect(() => {
    api.get("/schedule-events").then(({ data }) => setEvents(data)).catch(() => {});
  }, []);

  if (events.length === 0) return null;

  return (
    <>
      <section id="schedule" className="bg-white border-y-2 border-[#3D1E6D] py-10">
        <div className="max-w-7xl mx-auto px-4">
          <div className="mb-4">
            <Badge color="magenta">Schedule of Events</Badge>
            <h2 className="display text-3xl sm:text-4xl mt-2 text-[#3D1E6D]">What’s lined up</h2>
          </div>
          <div className="flex gap-5 overflow-x-auto no-scrollbar pb-3" data-testid="schedule-carousel">
            {events.map((e) => (
              <button
                key={e.id}
                type="button"
                onClick={() => setSelectedEvent(e)}
                className="shrink-0 w-[22rem] h-[22rem] kf-border kf-shadow bg-white overflow-hidden relative group cursor-pointer transition-transform hover:translate-x-[2px] hover:translate-y-[2px]"
                style={{ boxShadow: "4px 4px 0 #3D1E6D" }}
                data-testid={`schedule-photo-${e.id}`}
              >
                <img src={e.image_data} alt={e.title} className="w-full h-full object-cover" />
                <div className="absolute inset-x-0 bottom-0 bg-black/60 text-white px-3 py-2 opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="font-bold text-sm truncate">{e.title}</div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      {selectedEvent && (
        <div
          className="fixed inset-0 z-50 bg-black/85 backdrop-blur-sm grid place-items-center p-4"
          onClick={() => setSelectedEvent(null)}
          data-testid="schedule-modal"
        >
          <button
            onClick={() => setSelectedEvent(null)}
            className="absolute top-4 right-4 z-10 kf-border bg-white p-2 hover:bg-[#FFB400]"
            aria-label="Close"
          >
            <X className="h-5 w-5" />
          </button>
          <div className="max-w-6xl w-full max-h-[95vh] flex flex-col items-center" onClick={(e) => e.stopPropagation()}>
            <img
              src={selectedEvent.image_data}
              alt={selectedEvent.title}
              className="max-h-[80vh] w-auto max-w-full kf-border kf-shadow"
            />
            <div className="mt-4 w-full max-w-3xl text-center text-white">
              <div className="display text-3xl">{selectedEvent.title}</div>
              {selectedEvent.description && (
                <p className="mt-3 text-white/90 leading-relaxed">{selectedEvent.description}</p>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
